/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Button, Empty, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

import BarangayName from './BarangayName'
import BarangaySlogan from './BarangaySlogan'
import BarangayTelephone from './BarangayTelephone'
import BarangaySignatory from './BarangaySignatory'
import BarangayLogo from './BarangayLogo'
import MunicipalLogo from './MunicipalLogo'
import ORValidation from './ORvalidation'
import SignaturePhoto from './BarangaySignatoryPhoto'
import MunicipalName from './MunicipalName'
import MunicipalAddress from './MunicipalAddress'
// import GoogleDriveFolder from './GoogleDriveFolder'
import CityOrMunicipality from './CityOrMunicipality'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid } = AuthStore
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Utilities</a></li>
									<li className="breadcrumb-item active">System Settings</li>
								</ol>
							</div>
							<h4 className="page-title">System Settings</h4>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row type='flex' justify='center'>
									<Col md={12} sm={24}>
										<Row>
											<BarangayLogo />
										</Row>
										<Row>
											<MunicipalLogo />
										</Row>
										<Row>
											<CityOrMunicipality />
										</Row>
										<Row>
											<MunicipalAddress />
										</Row>
										<Row>
											<MunicipalName />
										</Row>
										<Row>
											<BarangayName />
										</Row>
										<Row>
											<BarangaySlogan />
										</Row>
										<Row>
											<BarangayTelephone />
										</Row>
										<Row>
											<BarangaySignatory />
										</Row>
										<Row>
											<SignaturePhoto />
										</Row>
										<Row>
											<ORValidation />
										</Row>
										{/* <Row>
											<GoogleDriveFolder />
										</Row> */}
									</Col>
								</Row>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
